import '.h2{line-height:1.375rem;}.ssr-plugin'
import '.bt{font-size:0.875rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.em{gap:0.38rem;}.ssr-plugin'
import '.gm{padding:0.5rem 1rem;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.ai{flex-grow:1;}.ssr-plugin'
import '.l{padding:0px;}.ssr-plugin'
import '.aw{border:none;}.ssr-plugin'
import '.ck{outline:none;}.ssr-plugin'
import '.cl{background:transparent;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  KeyboardEvent,
  MutableRefObject,
  forwardRef,
  FocusEventHandler,
  KeyboardEventHandler,
} from 'react'
import { Text } from '../../typography/Text'

export type TextInputProps = {
  text: string
  placeholder?: string
  label?: string
  errorMessage?: string
  style?: Style
  ref?: MutableRefObject<HTMLInputElement>
  setText: (text: string) => void
  onBlur?: FocusEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
}

export const BorderlessTextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      text,
      placeholder,
      label,
      errorMessage,
      style,
      setText,
      onBlur,
      onKeyDown,
    }: TextInputProps,
    ref,
  ) => {
    const errorStateOn = !!errorMessage
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
      if (onKeyDown) {
        onKeyDown(event)
      }
    }

    return (
      <styled.div className="h2 bt d e a8 em gm"
        style={{
          '&:has(:disabled)': {
            cursor: 'not-allowed',
          },
          ...style,
        }}
      >
        <div className="d r s"
          style={{
            background: errorStateOn
              ? 'var(--palette-red-100)'
              : 'var(--palette-white)',
          }}
        >
          {label && <styled.div>{label}</styled.div>}
          <styled.input className="ai l aw ck cl"
            placeholder={placeholder}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={onBlur}
            onKeyDown={handleKeyDown}
            ref={ref}
            style={{
              '&::placeholder': {
                color: errorStateOn
                  ? 'var(--palette-red-400)'
                  : 'var(--gray-300)',
                userSelect: 'none',
              },
              '&:disabled': {
                cursor: 'not-allowed',
              },
            }}
          ></styled.input>
        </div>
        {errorStateOn && (
          <Text.ExtraSmall style={{ color: 'var(--palette-red-600)' }}>
            {errorMessage}
          </Text.ExtraSmall>
        )}
      </styled.div>
    )
  },
)

BorderlessTextInput.displayName = 'BorderlessTextInput'
